import {
  COULD_NOT_VALIDATE_VOUCHER,
  INVALID_VOUCHER,
  VALIDATE_VOUCHER,
  VALID_VOUCHER,
} from '../actions/voucherValidation';

export const defaultState = {
  error: null,
  fetching: false,
  voucherCode: '',
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case COULD_NOT_VALIDATE_VOUCHER:
      return {
        ...state,
        error: action.payload,
        fetching: false,
        voucherCode: '',
      };
    case INVALID_VOUCHER:
      return {
        ...state,
        error: action.payload,
        fetching: false,
        voucherCode: '',
      };
    case VALIDATE_VOUCHER:
      return {
        ...state,
        fetching: true,
        error: action.payload,
      };
    case VALID_VOUCHER:
      return {
        ...state,
        error: null,
        fetching: false,
        voucherCode: action.payload,
      };
    default:
      return state;
  }
};
